'use strict'
import httpRequest from '../request/indexBase'
import { local } from '@/utils/storage'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import permissionHeader from '@/utils/permissionHeader'
// import { validMobile, validEmail } from '@/utils/validation'
const perModuleType = '0'
export function savePersonalDataLibrary(data, perFolderId = '') {
  return httpRequest.post({
    url: '/weaviate/personalDataLibrary/savePersonalDataLibrary',
    params: {
      perFolderId,
      perModuleType
    },
    data: data
  })
}

export function fileUpload(data, perFolderId = '') {
  return httpRequest.post({
    url: '/repository/files-record/fileUpload',
    data: data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}

// 单个保存
export function saveDataLibrary(data) {
  return httpRequest.post({
    url: '/weaviate/data-library-detail',
    data: data
  })
}

// 修改
export function updataDataLibrary(data) {
  return httpRequest.put({
    url: '/weaviate/data-library-detail',
    data: data
  })
}

// 删除
export function deleteLibraryDetail(data) {
  return httpRequest.post({
    url: '/weaviate/data-library-detail/deleteLibraryDetail',
    data: data
  })
}

export function detailData(params) {
  return httpRequest.get({
    url: `/weaviate/personalDataLibrary/${params.id}`
  })
}

export function getFileContentByUrl(params) {
  return httpRequest.get({
    url: `/weaviate/data-library-detail/getFileContentByUrl`,
    params
  })
}
// 查询未分类文件数量
export function queryUnclassifiedFileSize(params, perFolderId = '') {
  return httpRequest.get({
    url: `/weaviate/data-library-detail/queryUnclassifiedFileSize`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}
// 查询首层文件夹
export function getFirstLayerFolderList(params, perFolderId = '') {
  return httpRequest.get({
    url: `/weaviate/personalDataLibrary/getFirstLayerFolderList`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}
// 根据文件夹ID查询文件、文件夹数量
export function getFolderFileCount(params, perFolderId = '') {
  return httpRequest.get({
    url: `/weaviate/personalDataLibrary/getFolderFileCount`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}
// 根据文件夹ID查询文件数量
export function queryFileSizeByFolderId(folderId) {
  return httpRequest.get({
    url: `/weaviate/data-library-detail/queryFileSizeByFolderId?folderId=${folderId}`
  })
}
// 根据文件夹ID查询下层文件夹列表
export function getLayerFolderListByParentId(params, perFolderId = '') {
  return httpRequest.get({
    url: `/weaviate/personalDataLibrary/getLayerFolderListByParentId`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}
// 文件夹重命名
export function updatePersonalDataLibrary(data, perFolderId = '') {
  return httpRequest.put({
    url: '/weaviate/personalDataLibrary/updatePersonalDataLibrary',
    data: data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 文件夹排序
export function updateBatchFolder(data, perFolderId = '') {
  return httpRequest.put({
    url: `/weaviate/personalDataLibrary/updateBatchFolder`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 复制文件夹
export function copyPerDataLibFolder(data, perFolderId = '') {
  return httpRequest.post({
    url: `/weaviate/personalDataLibrary/copyPerDataLibFolder`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 移动文件夹
export function movePerDataLibFolder(data, perFolderId = '') {
  return httpRequest.post({
    url: `/weaviate/personalDataLibrary/movePerDataLibFolder`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 删除文件夹
export function deletePersonalDataLibrary(data, perFolderId = '') {
  return httpRequest.put({
    url: '/weaviate/personalDataLibrary/deletePersonalDataLibrary',
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 批量保存
export function libraryDetailSaveBatch(data, perFolderId = '') {
  return httpRequest.post({
    url: '/weaviate/data-library-detail',
    data: data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 根据文件id查询信息
export function getDetailById(teamId, ownerType, id, perFolderId = '') {
  return httpRequest.get({
    url: `/weaviate/data-library-detail/getDetailById`,
    params: {
      teamId,
      ownerType,
      id,
      perFolderId,
      perModuleType
    }
  })
}
// 根据文件id查询信息
export function getDataLibraryDetailById(id) {
  return httpRequest.get({
    url: `weaviate/data-library-detail/getDataLibraryDetailById`,
    params: {
      id
    }
  })
}
// 设置文件夹封面图
export function setFolderCoverImg(teamId, ownerType, id, perFolderId) {
  return httpRequest.get({
    url: `/weaviate/data-library-detail/setFolderCoverImg?id=${id}`,
    params: {
      teamId,
      ownerType,
      perFolderId,
      perModuleType
    }
  })
}
// 查询文件夹协作者
export function queryFolderCollaborators(params) {
  return httpRequest.get({
    url: `/permission/team-data-permission/getDataPermissionList`,
    params
  })
}
// 查询模块权限列表
export function queryModulePermissions(params) {
  return httpRequest.get({
    url: `/permission/data-permission/getSystemDataPermissionList`,
    params
  })
}
// 编辑单个文件夹协作者
export function editSingleFolderCollaborator(data) {
  return httpRequest.put({
    url: `/permission/team-data-permission/updateUserPermission`,
    data
  })
}
// 查询文件夹协作者（不包含归属者）
export function queryFolderCollaboratorsNotCreate(params) {
  return httpRequest.get({
    url: `/permission/team-data-permission/getDataPermission`,
    params
  })
}
// 管理文件夹协作者
export function manageFolderCollaborators(data) {
  return httpRequest.put({
    url: `/permission/team-data-permission/updateDataPermission`,
    data
  })
}
// 查询用户文件夹的查看权限
export function queryFolderPermissions(params, perFolderId = '') {
  return httpRequest.get({
    url: `/permission/team-data-permission/getUserDataPermission`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}
// 云空间查询
export function queryCloudSpace(params) {
  return httpRequest.get({
    url: `/repository/data-cloud-space/getCloudSpace`,
    params
  })
}
// 编辑修改文件夹信息
export function changeFileInfo(data, perFolderId = '') {
  return httpRequest.put({
    url: `/weaviate/data-library-detail`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 编辑修改提示词信息
export function savePromptInfo(data, perFolderId = '') {
  return httpRequest.put({
    url: `/weaviate/data-library-detail/updateBaseFilesPrompt`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 分享链接
export function shareRecord(data) {
  return httpRequest.post({
    url: `/weaviate/base-share-record`,
    data
  })
}
// 取消分享
export function changeShareRecord(data) {
  return httpRequest.put({
    url: `/weaviate/base-share-record`,
    data
  })
}
// code查询分享信息
export function getShareRecordByCode(code, password) {
  return httpRequest.get({
    url: `/weaviate/base-share-record/getShareRecordByCode?shareCode=${code}&password=${password}`
  })
}
// 查询AI助手的问题
export function queryBaseProblem(data) {
  return httpRequest.get({
    url: `/weaviate/base-dia-record/queryBaseProblem?diaBoxId=${data.diaBoxId}&type=${data.type}`
  })
}
// 根据会话ID查询知识库AI会话内容
export function queryRecordByDiaBoxId(diaBoxId) {
  return httpRequest.get({
    url: `/weaviate/base-dia-record/queryRecordByDiaBoxId?diaBoxId=${diaBoxId}`
  })
}
// 新建知识库对话
export function createDiabox(data) {
  return httpRequest.post({
    url: `/weaviate/base-dia-box`,
    data
  })
}
// 修改知识库对话信息
export function changeDiabox(data) {
  return httpRequest.put({
    url: `/weaviate/base-dia-box`,
    data
  })
}
// 删除知识库对话信息
export function deleteDiabox(data) {
  return httpRequest.delete({
    url: `/weaviate/base-dia-box?ids[]=${data.ids}`
  })
}
// // 查询知识库对话内容
// export function getDiabox(id) {
//   return httpRequest.get({
//     url: `/weaviate/base-dia-box/${id}`
//   })
// }
// 分页查询知识库对话记录
export function getDiaboxHistory(data) {
  return httpRequest.get({
    url: `/weaviate/base-dia-box/page?title=${data.title}&current=${data.current}&size=${data.size}&baseFolderId=${data.baseFolderId}&baseFileId=${data.baseFileId}&type=${data.type}`,
    data
  })
}
// 保存分享文件/ai-backend/weaviate/base-share-record/baseShareFileTransfer
export function baseShareFileTransfer(data, perFolderId = '') {
  return httpRequest.post({
    url: `/weaviate/base-share-record/baseShareFileTransfer`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
// 发送会话
export function sendChat(data, onopen, onmessage, onclose, onerror) {
  const ctrl = new AbortController()
  return fetchEventSource(process.env.VUE_APP_API_URL + '/chatWeaviate/chatKnowledgeBase', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      token: local.get('TOKEN'),
      ...permissionHeader()
    },
    body: JSON.stringify(data),
    openWhenHidden: true,
    signal: ctrl.signal,
    onopen(response) {
      console.log('请求成功开始发送-----------------------')
      // 开启流
      onopen && onopen(response)
    },
    onmessage(event) {
      // 监听流
      onmessage && onmessage(event)
    },
    onclose(e) {
      console.log('请求结束--------------------------------')
      // 关闭流
      onclose && onclose(e)
    },
    onerror: (e) => {
      //返回流报错
      console.log('请求失败--------------------------------')
      ctrl.abort()
      onerror && onerror(e)
      throw e
    }
  })
}
// 查询文件夹列表
export function queryFolderList(params, perFolderId = '') {
  return httpRequest.get({
    url: `/weaviate/personalDataLibrary/getLayerFolderListByParentId`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}
// 根据url查询文档内容/ai-backend/repository/files-record/getFileContentByUrl
export function getFileByUrl(url) {
  return httpRequest.get({
    url: `/repository/files-record/getFileContentByUrl?url=${url}`
  })
}
// 根据文件id查询对应文件
export function queryDataDetailPage(data, perFolderId = '') {
  return httpRequest.post({
    url: `/weaviate/data-library-detail/queryDataDetailPage`,
    data,
    params: { perFolderId, perModuleType }
  })
}
// 查询用户有无文件夹管理协作者权限/ai-backend/permission/team-data-permission/getUserFolderPermission
export function getUserFolderPermission(folderId = '', moduleType = '', ownerType) {
  return httpRequest.get({
    url: `/permission/team-data-permission/getUserFolderPermission`,
    params: { folderId, moduleType, ownerType }
  })
}
// 保存用户上传知识库文件+文件夹
export function saveUploadDatabaseFiles(data, perFolderId = '') {
  return httpRequest.post({
    url: `/weaviate/data-library-detail/saveUploadDataLibrary`,
    data,
    params: { perFolderId, perModuleType }
  })
}
// 查询标签
export function fileTag(data) {
  return httpRequest.get({
    url: `/weaviate/file-tag/page`,
    params: { ...data }
  })
}
// 下载文件和文件夹
export function downloadFolderAndFile(data) {
  return httpRequest.post({
    url: `/weaviate/personalDataLibrary/downloadFolderAndFile`,
    data,
    responseType: 'blob'
  })
}
// 下载文件和文件夹--分享页
export function shareDownFolderAndFile(data) {
  return httpRequest.post({
    url: `/weaviate/base-share-record/shareDownFolderAndFile`,
    data,
    responseType: 'blob'
  })
}
// 下载文件前校验
export function downVerify(data) {
  return httpRequest.post({
    url: `/weaviate/base-share-record/downVerify`,
    data
  })
}
// 查询文件是否重复
export function checkFileByFileName(data) {
  return httpRequest.post({
    url: `/weaviate/data-library-detail/checkFileByFileName`,
    data
  })
}
// 查询上级文件
export function getUpwardAndPeerFoldeList(data) {
  return httpRequest.get({
    url: `/weaviate/personalDataLibrary/getUpwardAndPeerFoldeList`,
    params: { ...data }
  })
}
// 轮旋查询转换状态/ai-backend/weaviate/file-image-task/getFileToImageStatusByFileIdList
export function getFileToImageStatusByFileIdList(data) {
  return httpRequest.post({
    url: `/weaviate/file-image-task/getFileToImageStatusByFileIdList`,
    data
  })
}
// 重试转换/ai-backend/weaviate/data-library-detail/retryFileToImageData
export function retryFileToImageData(data) {
  return httpRequest.post({
    url: `/weaviate/data-library-detail/retryFileToImageData`,
    data
  })
}
// 查询用户上传文件大小配置/ai-backend/repository/user-upload-config/getUserUploadConfig
export function getUserUploadConfig(data) {
  return httpRequest.get({
    url: `/repository/user-upload-config/getUserUploadConfig`,
    params: { ...data }
  })
}
// 查询文件转图片状态
export function getFileToImageStatusByFileId(params) {
  return httpRequest.get({
    url: `/weaviate/file-image-task/getFileToImageStatusByFileId`,
    params
  })
}
